export default "__VITE_ASSET__039TVCJ1__"